"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var itemBelongsToSite = function itemBelongsToSite(item) {
  var _item$fields, _item$fields$site;
  return item === null || item === void 0 ? void 0 : (_item$fields = item.fields) === null || _item$fields === void 0 ? void 0 : (_item$fields$site = _item$fields.site) === null || _item$fields$site === void 0 ? void 0 : _item$fields$site.includes(process.env.NEXT_PUBLIC_SITE);
};
var _default = itemBelongsToSite;
exports["default"] = _default;